import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import { get } from '@Domain/Api';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import ApiError from '@Infra/FetchLib/ApiError';

type BeneficiaryAccess = 'accessible' | 'inaccessible';

/**
 * Re-reads a subject file only to learn whether the current account can still open it. No
 * dispatch, no store, no toast: the answer is consumed by the caller and nothing else. A 403 or 404
 * means the file is out of reach; any other failure (network, 5xx, 401 after refresh) is rethrown,
 * because it says nothing about access.
 */
const probeBeneficiaryAccess = async (
	facilityId: number,
	subject: SubjectAddress,
): Promise<BeneficiaryAccess> => {
	try {
		await get<unknown>(buildSubjectApiPath(facilityId, subject));

		return 'accessible';
	} catch (error) {
		if (error instanceof ApiError && (error.status === 403 || error.status === 404)) {
			return 'inaccessible';
		}

		throw error;
	}
};

export default probeBeneficiaryAccess;
export type { BeneficiaryAccess };
